module.exports = __webpack_public_path__ + "img/logo_dream.6b33d07d.png";